import type { RouterOutputs } from "@api/trpc/routers/_app";
import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";

const RatingStarButton = ({
  studySet,
  disabled,
}: {
  studySet: RouterOutputs["studysets"]["getById"];
  disabled: boolean;
}) => {
  return (
    <Button
      variant="ghost"
      size="sm"
      disabled={disabled}
      className="inline-flex gap-2 px-1"
    >
      <Star className="size-4 text-[#FDE047] fill-[#FDE047] stroke-yellow-400" />
      <span className="text-muted-foreground text-sm font-medium">
        {Number(studySet.averageRating).toFixed(1)} ({studySet.totalRatings}{" "}
        reviews)
      </span>
    </Button>
  );
};

export default RatingStarButton;
